import styled from "styled-components";

export const LoginStyles = styled.div`

.images-section-div{
    position: relative;
    width: 100%;
}
.images-section-div img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.images-section-div .transparent-btn {
  background-color: transparent;
    border: none;
    color: #007bff;
    font-size: 16px;
    padding: 10px 20px;
    position: absolute;
    cursor: pointer;
    right: 23%;
    top: 35%;
    height: 31px;
  }
  .images-section-div .transparent-btn-r {
    background-color: transparent;
    border: none;
    color: #007bff;
    font-size: 16px;
    padding: 10px 20px;
    position: absolute;
    cursor: pointer;
    right: 39%;
    top: 50%;
    width: 170px;
    height: 40px;
  }
  .images-section-div .transparent-btn-c {
    background-color: transparent;
    border: none;
    color: #007bff;
    font-size: 16px;
    padding: 10px 20px;
    position: absolute;
    cursor: pointer;
    right: 39%;
    top: 55%;
    width: 365px;
    height: 30px;
    z-index: 99;
  }

`